import { render, staticRenderFns } from "./CommonFoot.vue?vue&type=template&id=455ed79c&scoped=true&"
import script from "./CommonFoot.vue?vue&type=script&lang=js&"
export * from "./CommonFoot.vue?vue&type=script&lang=js&"
import style0 from "./CommonFoot.vue?vue&type=style&index=0&id=455ed79c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "455ed79c",
  null
  
)

export default component.exports